import { View, Text, StyleSheet } from 'react-native';
import React, { useState } from 'react';

import Constants from '../constants';
import { LeadContext, leadReducer } from '../contexts/lead';
import CampaignOverview from '../components/CampaignOverview';
import PitchProvider from '../components/Pitch/PitchProvider';
import { useParams } from './../react-router';
import CampaignLandingPage from './../components/Campaign/CampaignLandingPage';
import GroupLandingPage from '../components/Leads/GroupLandingPage';


export default function GroupLandingPageProvider(): JSX.Element {
  const [state, dispatch] = React.useReducer(leadReducer, {});
  const params = useParams();

  return (
    <View style={{ flex: 1 }}>
      <LeadContext.Provider value={{ state, dispatch }}>
        <GroupLandingPage groupCode={params.groupCode} />
      </LeadContext.Provider>
    </View>
  );
}
